import { createTRPCProxyClient, httpBatchLink } from "@trpc/client";
import type { StudioAppRouter } from "@truman/lambda/api/studio-trpc/main";
import { maintenanceAwareFetch } from "./maintenance-fetch";

/**
 * Vanilla browser-side tRPC client for non-component modules
 * (lib/file-utils.ts). Uses the same relative /api/trpc proxy as the React
 * provider; do not import from server components.
 */
export const trpcBrowserClient = createTRPCProxyClient<StudioAppRouter>({
  links: [httpBatchLink({ url: "/api/trpc", fetch: maintenanceAwareFetch })],
});
